import React, { useState } from "react";
import MarketTradeHour from "./MarketTradeHour";
import WorkingCalender from "./WorkingCalender";
import { TabBox } from "src/Components";

enum TabIndex {
  MarketTradeHour,
  WorkingCalendar,
}

const DateAndTime = () => {
  const [tabIndex, setTabIndex] = useState(TabIndex.MarketTradeHour);

  const getTabUI = () => {
    switch (tabIndex) {
      case TabIndex.MarketTradeHour:
        return <MarketTradeHour />;

      case TabIndex.WorkingCalendar:
        return <WorkingCalender />;

      default:
        return <></>;
    }
  };

  return (
    <div className="w-full flex flex-col justify-start items-start gap-3 px-3">
      <div className="w-min">
        <TabBox
          activeTab={tabIndex}
          children={[
            { index: TabIndex.MarketTradeHour, title: "ساعت معامله" },
            { index: TabIndex.WorkingCalendar, title: "تقویم کاری" },
          ]}
          onChange={(_, i) => setTabIndex(i)}
        />
      </div>
      {getTabUI()}
    </div>
  );
};

export default DateAndTime;
